// -------------------------------声明-------------------------------------------
// <auto-generated>
//     此文件是自动生成的文件，对这个文件的任何修改在下次自动生成的时候都会丢失。
//     模板名称：\TTFiles\TS\Entity\CommonService.tt
// </auto-generated>
// ------------------------------------------------------------------------------
import { MenuSet } from './MenuSet';
import { get, post, put, del } from '../../../../../../libs/com/MetaPattern/Product/IDE/Util/Request';
import { RequestResult } from '../../../../../../libs/com/MetaPattern/Product/IDE/Util/RequestResult';
import { Condition } from '../../../../../../libs/com/MetaPattern/Product/IDE/Util/Condition';
/**
 * 菜单集 通用服务类
 * 菜单集
 */
export class MenuSetService {
  /**
   * 实体 菜单集 的通用CRUD服务
   * @menuSet 要创建的实体：菜单集
   * @return 返回：创建的实体
   */
  static async CreateAsync(menuSet: MenuSet): Promise<MenuSet | null> {
    return new Promise((resolve, reject) => {
      post('metapattern-ide-mmdapp/api/menuset/create', menuSet.toJson())
        .then((response: any) => {
          if (response) {
            const result = MenuSet.Create(response);
            resolve(result);
          } else {
            resolve(null);
          }
        })
        .catch(error => {
          // TODO : 格式化错误返回
          reject(error);
        });
    });
  }

  /**
   * 实体 菜单集 的通用CRUD服务：根据ID加载实体
   * @param id 要查询的实体id
   * @return 返回：实体DTO
   */
  static async LoadByIdAsync(id: string): Promise<MenuSet | null> {
    return new Promise((resolve, reject) => {
      get('metapattern-ide-mmdapp/api/menuset/loadbyid', { id: id })
        .then((response: any) => {
          if (response) {
            const result = MenuSet.Create(response);
            resolve(result);
          } else {
            resolve(null);
          }
        })
        .catch(error => {
          // TODO : 格式化错误返回
          reject(error);
        });
    });
  }

  /**
   * 实体 菜单集 的通用CRUD服务：根据ID加载实体
   * @param ids 要查询的实体id列表
   * @return 返回：实体DTO列表
   */
  static async LoadByIdsAsync(ids: Array<string>): Promise<Array<MenuSet>> {
    return new Promise((resolve, reject) => {
      get('metapattern-ide-mmdapp/api/menuset/loadbyids', { ids: ids.join(',') })
        .then((response: any) => {
          const result = new Array<MenuSet>();
          if (response) {
            response.forEach((item: MenuSet) => {
              result.push(MenuSet.Create(item));
            });
          }
          resolve(result);
        })
        .catch(error => {
          // TODO : 格式化错误返回
          reject(error);
        });
    });
  }

  /**
   * 实体 菜单集 的通用CRUD服务：获取所有有效的实体
   * @return 返回：实体DTO列表
   */
  static async LoadAllAsync(): Promise<Array<MenuSet>> {
    return new Promise((resolve, reject) => {
      get('metapattern-ide-mmdapp/api/menuset/loadall')
        .then((response: any) => {
          const result = new Array<MenuSet>();
          if (response) {
            response.forEach((item: MenuSet) => {
              result.push(MenuSet.Create(item));
            });
          }
          resolve(result);
        })
        .catch(error => {
          // TODO : 格式化错误返回
          reject(error);
        });
    });
  }

  /**
   * 实体 菜单集 的通用CRUD服务：更新实体
   * @menuSet 要更新的实体：菜单集
   * @return 返回：更新后的实体
   */
  static async UpdateAsync(menuSet: MenuSet): Promise<MenuSet | null> {
    return new Promise((resolve, reject) => {
      put('metapattern-ide-mmdapp/api/menuset/update', menuSet.toJson())
        .then((response: any) => {
          if (response) {
            const result = MenuSet.Create(response);
            resolve(result);
          } else {
            resolve(null);
          }
        })
        .catch(error => {
          // TODO : 格式化错误返回
          reject(error);
        });
    });
  }

  /**
   * 实体 菜单集 的通用CRUD服务 ：根据id逻辑删除实体
   * @param id 要删除的实体id
   * @return 返回：是否成功执行
   */
  static async DeleteAsync(id: string): Promise<boolean> {
    return new Promise((resolve, reject) => {
      del('metapattern-ide-mmdapp/api/menuset/deletebyid', { id: id })
        .then((response: any) => {
          if (response) {
            const result = response as boolean;
            resolve(result);
          } else {
            resolve(false);
          }
        })
        .catch(error => {
          // TODO : 格式化错误返回
          reject(error);
        });
    });
  }

  /**
   * 实体 菜单集 的通用CRUD服务 ：根据id列表逻辑删除实体
   * @param ids 要删除的实体id列表
   * @return 返回：成功删除的条数
   */
  static async DeleteBatchAsync(ids: Array<string>): Promise<number> {
    return new Promise((resolve, reject) => {
      del('metapattern-ide-mmdapp/api/menuset/deletebyids', { ids: ids.join(',') })
        .then((response: any) => {
          if (response) {
            const result = response as number;
            resolve(result);
          } else {
            resolve(0);
          }
        })
        .catch(error => {
          // TODO : 格式化错误返回
          reject(error);
        });
    });
  }
}
